import Vue from "vue";
import App from "./App.vue";
import router from "@/router";
import store from "@/store";
import "@/plugins/element.js";
import 'element-ui/lib/theme-chalk/display.css'
import VueMq from "vue-mq";
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import 'nprogress/nprogress.css';
import '@/assets/scss/app.scss';


Vue.use(VueAwesomeSwiper);

Vue.config.productionTip = false;
Vue.use(VueMq, {
    breakpoints: {
        mobile: 450,
        tablet: 900,
        laptop: 1250,
        desktop: Infinity
    }
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");